var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUnblockIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 20,
    viewBox: "0 0 14 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 7.81258V5.62508C12 4.64051 11.7093 3.67785 11.1644 2.85781C10.6196 2.03777 9.84467 1.39686 8.93698 1.01544C8.02929 0.634017 7.0292 0.52907 6.0621 0.713755C5.09501 0.898441 4.20396 1.36454 3.5007 2.0536L4.3757 2.94637C4.90316 2.42963 5.57144 2.08011 6.29674 1.94163C7.02204 1.80315 7.77208 1.88189 8.45282 2.16796C9.13355 2.45403 9.71468 2.9347 10.1233 3.54971C10.532 4.16471 10.75 4.88668 10.75 5.62508V7.81258H0.4375V12.8126C0.4375 16.4312 3.38141 19.3751 7 19.3751C10.6186 19.3751 13.5625 16.4312 13.5625 12.8126V7.81258H12ZM12.3125 12.8126C12.3125 15.7419 9.92934 18.1251 7 18.1251C4.07066 18.1251 1.6875 15.7419 1.6875 12.8126V9.06258H12.3125V12.8126Z",
    fill: "#777"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnblockIcon);
export default __webpack_public_path__ + "static/media/unblock-icon.8876d15a9a51ab76b7681246d95d3440.svg";
export { ForwardRef as ReactComponent };